import { zeroTextFieldStyles } from '@genesislcap/foundation-zero';
import { css, ElementStyles } from '@microsoft/fast-element';
import { ElementDefinitionContext, FoundationElementDefinition } from '@microsoft/fast-foundation';
import Calendar from '../../../assets/calendar.svg';

export const customTextFieldStyles = (
  context: ElementDefinitionContext,
  definition: FoundationElementDefinition
): ElementStyles => css`
  ${zeroTextFieldStyles(context, definition)}
  input {
    color-scheme: dark;
  }

  input[type='date']::-webkit-calendar-picker-indicator {
    background: transparent;
    bottom: 0;
    color: transparent;
    cursor: pointer;
    height: auto;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    width: auto;
  }

  input[type='date']::after {
    content: '';
    width: 11px;
    height: 11px;
    background: url(${Calendar}) no-repeat;
    display: inline-block;
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translate(0, -50%);
    pointer-events: none;
  }
`;
